<script setup lang="ts">
import type { TavoParams, TavoWidget } from "."
import { useTavo } from "."
import { useTavoConfig, useTavoParams } from "./config"

const { tavoScript } = useTavo()
const tavoParams = useTavoParams()
const tavoConfig = useTavoConfig()
const tavoKey = ref(formatKey(tavoParams.value))
const tavoWidget = useTemplateRef<TavoWidget>("tavoWidget")

function formatKey(params: TavoParams) {
    if (!params.location) {
        return `${params.group}-${params.concept}`
    }
    return `${params.group}-${params.concept}-${params.location}`
}

watch(tavoParams, (value) => {
    tavoKey.value = formatKey(value)
})

watch(tavoConfig, (value) => {
    if (value && tavoWidget.value) {
        tavoWidget.value.fonts = value.fonts
        tavoWidget.value.styles = value.styles
    }
})

watch(tavoWidget, (value) => {
    if (value && tavoConfig.value) {
        value.fonts = tavoConfig.value.fonts
        value.styles = tavoConfig.value.styles
    }
})
</script>

<template>
    <tavo-widget
        v-if="tavoScript"
        :key="tavoKey"
        ref="tavoWidget"
        class="z-[1000]"
    />
</template>